var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","font-size":"25px","text-align":"center","padding-top":"8rem"}},[_c('div',{staticStyle:{"width":"100%","height":"12rem","text-align":"center"}},[_c('Icon',{attrs:{"type":"md-information-circle","size":"186","color":"#5cadff"}})],1),_vm._v("\n\t请使用微信客户端打开\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-434abfe5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/WeChat/noWxBrowser/index.vue
// module id = null
// module chunks = 